import React, { createContext, useEffect, useState } from 'react'
import { myAccount } from 'services/api/authentication'
import Cookies from 'universal-cookie'
import { clearCookies } from 'services/helper/clearCookies'

const cookies = new Cookies()
export const authContext = createContext({})

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    loading: true,
    isAuth: false,
    profilePhoto: null,
    cv: null,
    userId: null,
    userType: null,
    cvStatus: null,
    score: null,
  })

  const setAuthData = async () => {
    // DEV ONLY: Auto-set token from env var if not logged in
    const isLocal = process.env.REACT_APP_ENV === 'local'
    if (isLocal && process.env.REACT_APP_DEV_TOKEN && !cookies.get('access_token')) {
      const expires = new Date()
      expires.setDate(expires.getDate() + 30)
      cookies.set('access_token', process.env.REACT_APP_DEV_TOKEN, {
        path: '/',
        expires,
        domain: process.env.REACT_APP_DOMAIN,
      })
      cookies.set('token_expired', Math.floor(Date.now() / 1000) + (30 * 24 * 60 * 60), {
        path: '/',
        expires,
        domain: process.env.REACT_APP_DOMAIN,
      })
      console.log('🛠️ Dev token auto-set from REACT_APP_DEV_TOKEN')
    }

    // If Token Already Expired Logout User
    if (cookies.get('access_token')) {
      if (cookies.get('token_expired') < Date.now() / 1000) {
        clearCookies()
        setAuth({ loading: false, isAuth: false })
      } else {
        try {
          const results = await myAccount()
          const userData = results?.data || results

          if (!userData) {
            console.warn('🔐 Auth check: No user data returned')
            setAuth({ loading: false, isAuth: false })
            return
          }

          // If Account is Employer Logout User
          if (userData.account_type === 'employer') {
            console.warn('🔐 Auth check: Logged in as employer (not allowed)')
            clearCookies()
            setAuth({ loading: false, isAuth: false })
          } else if (userData.account_type === 'jobseeker') {
            console.log('✅ Auth check: Logged in as jobseeker')
            // Check either profile is complete or not to apply for courses
            const profileStatus = userData.profile_status || {}
            const about_me = profileStatus.about_me || 0

            const profileCompleteArray = [about_me]
            const profileComplete = profileCompleteArray.every((item) => item === 1)

            setAuth({
              loading: false,
              isAuth: true,
              profilePhoto: userData.profile_image_url,
              cv: true,
              cvStatus: profileStatus.cv,
              photoStatus: profileStatus.photo,
              userId: userData.id,
              profilePhotoName: userData.profile_image,
              profileStatus: about_me,
              userType: userData.account_type,
              score: userData.score_weight,
              profileComplete,
            })
          }
        } catch (e) {
          console.error('❌ Auth check: API Error', e)
          setAuth({ loading: false, isAuth: false })
        }
      }
    } else {
      setAuth({ loading: false, isAuth: false })
    }
  }

  const logoutUser = () => {
    setAuth({
      loading: false,
      isAuth: false,
      profilePhoto: null,
      cv: null,
      userId: null,
      userType: null,
      cvStatus: null,
      score: null,
    })
  }

  useEffect(() => {
    setAuthData()
  }, [auth.isAuth])

  return (
    <authContext.Provider value={{ auth, setAuthData, logoutUser }}>
      {children}
    </authContext.Provider>
  )
}

export default AuthProvider
